import { SetStateAction, useState } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";

import { Modal } from "../components";
import { StyledButton } from "../components";
import { purple } from "../config";
import { SlideData } from "../interfaces/question.interface";
import RenderQuestion from "./RenderQuestion";
import { FaCaretLeft } from "react-icons/fa";
import useTranslatePageText from "@natklok/hooks/useTranslatePageText";

const SeeQuestionAgainButton: React.FC<{ slideData: SlideData }> = ({ slideData }) => {
  const [showAnswerModalVisible, setShowAnswerModalVisible] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const translatePageText = useTranslatePageText();

  return (
    <>
      <StyledButton
        variant="secondary"
        style={{ flex: 1, justifyContent: "space-between" }}
        onClick={() => {
          setShowAnswerModalVisible(true);
        }}
      >
        <FaCaretLeft />{" "}
        {isMobile
          ? translatePageText("general.seeQuestionAgainMobile")
          : translatePageText("general.seeQuestionAgain")}
        <div />
      </StyledButton>
      <RenderQuestionModal
        modalVisible={showAnswerModalVisible}
        setModalVisible={setShowAnswerModalVisible}
        questionSlide={slideData}
      />
    </>
  );
};

const RenderQuestionModal: React.FC<{
  modalVisible: boolean;
  setModalVisible: React.Dispatch<SetStateAction<boolean>>;
  questionSlide: SlideData;
}> = ({ modalVisible, setModalVisible, questionSlide }) => {
  return (
    <Modal
      open={modalVisible}
      setOpen={setModalVisible}
      title=""
      style={{ background: purple[500], width: "90vw", height: "90vh" }}
    >
      <Box color="white" height="100%">
        <RenderQuestion showCorrectAnswer={true} question={questionSlide.question} readonly />
      </Box>
    </Modal>
  );
};

export default SeeQuestionAgainButton;
